import Alert from 'components/atoms/Alert'
import {
    TOGGLE_MODAL,
    SELECT_TABLE_ITEM,
    TRACKED_BUSINESSES,
    REMOVE_TRACKED_BUSINESS,
    SAVE_BUSINESS_DATA,
    SET_COUNTRIES,
    COMMISSION_CONFIG,
    REFRESHER
} from './app.type'

const APP_INIT_STATE = {
    modal_state: false,
    refreshState: false,
    tableItem: '',
    trackedbusinesses: [],
    businessData: [],
    countries: [],
    commissionConfig: []
}

const AppReducer = (state = APP_INIT_STATE, action) => {
    switch (action.type) {
        case TOGGLE_MODAL:
            return {
                modal_state: action.payload
            }
        case REFRESHER:
            return {
                ...state,
                refreshState: !state.refreshState
            }
        case SELECT_TABLE_ITEM:
            return {
                ...state,
                tableItem: action.payload
            }
        case TRACKED_BUSINESSES:
            const lastItem = action.payload.length - 1;
            const filtered = action.payload.filter((item, index) => index === lastItem).map(item => item).toString();

            if (action.payload.length <= 6) {
                if (state.trackedbusinesses.includes(filtered)) {
                    Alert('error', 'This Business is already being tracked');

                    return {
                        ...state
                    }
                } else {
                    return {
                        ...state,
                        trackedbusinesses: action.payload
                    }
                }
            } else {
                Alert('error', 'Maximum number of Businesses reached');
                return {
                    ...state
                }
            }
        case REMOVE_TRACKED_BUSINESS:
            const returnedState = state.trackedbusinesses.filter(item => item !== action.payload)

            return {
                ...state,
                trackedbusinesses: returnedState
            }
        case SAVE_BUSINESS_DATA:
            return {
                ...state,
                businessData: action.payload
            }
        case SET_COUNTRIES:
            return {
                ...state,
                countries: action.payload
            }
        case COMMISSION_CONFIG:
            return {
                ...state,
                commissionConfig: action.payload
            }
        default:
            return state;
    }
}

export default AppReducer